import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "state-page d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-md-8 col-lg-6 col-xl-5" }
const _hoisted_5 = { class: "card state-card text-center" }
const _hoisted_6 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"state-icon state-icon--danger\" data-v-efacfca2><i class=\"fa-sharp fa-solid fa-lock\" data-v-efacfca2></i></div><span class=\"state-eyebrow\" data-v-efacfca2>Acceso restringido</span><h1 class=\"state-title\" data-v-efacfca2>No tienes permiso para ver esta sección</h1><p class=\"state-text\" data-v-efacfca2> Tu cuenta no cuenta con el permiso necesario para entrar aquí. Si crees que deberías tener acceso, contacta a un administrador para que revise tu perfil. </p>", 4)),
              _createVNode(_component_router_link, {
                to: "/home",
                class: "btn btn-primary state-cta"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "fa-sharp fa-solid fa-house fa-fw" }, null, -1),
                  _createTextVNode(" Ir a inicio ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}